import axios from 'axios';
import { isEmpty } from 'lodash';
import userService from '../user.service';
import useStore, { updateUser, clearUser } from '../Store/Store';
import moment from 'moment';
import { getAuth, signOut } from 'firebase/auth';
import { auth } from './firebase';

const careUserType = {
  careRecipient: 'CARE_RECIPIENT',
  cargiver: 'CAREGIVER',
};

export const getSignedImage = (userId, imageUrl) => {
  return axios.post(
    `${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/getSignedUrl`,
    { url: imageUrl },
    {
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('auth'),
        'ngrok-skip-browser-warning': 'true',
      },
    },
  );
};

export const logout = async (history) => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Firebase sign out error:', error);
  }

  const user = useStore.getState().user;
  if (!isEmpty(user?.canCareCaregivers) && user?.careUserType === careUserType.careRecipient) {
    localStorage.setItem('showAddCaregiver', 0);
  } else {
    localStorage.setItem('showAddCaregiver', 1);
  }
  localStorage.setItem('showMissingData', 1);
  return fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/users/logout`, {
    method: 'POST',
    headers: {
      'ngrok-skip-browser-warning': 'true',
      'Content-Type': 'application/json',
      authorization: sessionStorage.getItem('token') || localStorage.getItem('auth'),
    },
    body: JSON.stringify({
      fcmToken: localStorage.getItem('fcmToken'),
    }),
  })
    .then((res) => {
      if (res.status !== 204) {
        throw new Error('Logout failed');
      }
    })
    .then(() => {
      localStorage.removeItem('selectedRecipient');
      localStorage.removeItem('auth');
      localStorage.removeItem('fcmToken');
      userService.clearUserData();
      clearUser();
      history('/login');
    })
    .catch((err) => {
      console.log(err);
    });
};

export const refresh = async () => {
  const user = useStore.getState().user;
  const userId = user?.id || user?._id;
  setTimeout(async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_EXPRESS_URL}/api/users/${userId}/userInfo`, {
        headers: {
          authorization: localStorage.getItem('auth'),
          'ngrok-skip-browser-warning': 'true',
        },
      });
      updateUser(data?.data);
    } catch (error) {
      console.log('refresh error =====> ', error);
    }
  }, 300);
};

export const chatDateFormat = (date) => {
  return moment(date?.seconds * 1000 + date?.nanoseconds / 1e6 || '').fromNow();
};

export const getTimeZoneOffset = () => {
  const now = new Date();
  const timeZoneOffsetMinutes = now.getTimezoneOffset();
  const offsetHours = timeZoneOffsetMinutes / -60;

  const offsetSign = offsetHours >= 0 ? '+' : '-';
  const offsetString = Math.abs(offsetHours).toString().padStart(2, '0');

  return `GMT${offsetSign}${offsetString}`;
};

export const getTimeZoneOffsetInteger = () => {
  const now = new Date();
  const timeZoneOffsetMinutes = now.getTimezoneOffset();
  const offsetHours = timeZoneOffsetMinutes / -60;

  return offsetHours;
};

export const getWeekdaysWithDates = () => {
  const today = moment();
  const days = [];

  for (let i = -3; i <= 3; i++) {
    const day = today.clone().add(i, 'days');
    days.push(day);
  }

  return days;
};

export const generateTimeList = () => {
  const times = [];
  const pad = (num) => (num < 10 ? `0${num}` : num);

  for (let hour = 0; hour < 24; hour++) {
    for (let minutes = 0; minutes < 60; minutes += 30) {
      times.push(`${pad(hour)}:${pad(minutes)}`);
    }
  }

  return times;
};
export const getFormattedChartPeriodLabel = (period, periodValue) => {
  switch (period) {
    case 'monthly':
      return `Week ${periodValue + 1}`;
    case 'weekly':
      return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][periodValue] || `Day ${periodValue}`;
    case 'daily':
      return `${periodValue.toString().padStart(2, '0')}:00`;
    default:
      return `Day ${periodValue}`;
  }
};

export const fixedDecimalToTwo = (value) => Number(value || 0).toFixed(2);
